/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./movePartyList.vue?vue&type=template&id=1f6c6bca&scoped=true&"
import script from "./movePartyList.vue?vue&type=script&lang=js&"
export * from "./movePartyList.vue?vue&type=script&lang=js&"
import style0 from "./movePartyList.vue?vue&type=style&index=0&id=1f6c6bca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6c6bca",
  null
  
)

export default component.exports